module.exports = {
    bindings: {
        referenceNumber: '<'
    },
    controller: customsOfficeDetailsController,
    templateUrl: 'customs-offices/components/customs-office-details.html'
}

customsOfficeDetailsController.$inject = [
    '$location',
    '$translate',
    '$window',
    'customsOfficeDataService',
    'countryHolidayModal',
    'language'
];

function customsOfficeDetailsController(
    $location,
    $translate,
    $window,
    customsOfficeDataService,
    countryHolidayModal,
    language
) {
    var vm = {
        $onInit: attached,
        $onDestroy: detached,
        service: customsOfficeDataService,
        isLoading: false,
        activelsdCode: null,
        back: back,
        selectLanguage: selectLanguage,
        customsOffice: null,
        weekdays: { 1: 'Monday', 2: 'Tuesday', 3: 'Wednesday', 4: 'Thursday', 5: 'Friday', 6: 'Saturday', 7: 'Sunday' },
        timeTable: [],
        clickReference: clickReference,
        showCountryHolidays: showCountryHolidays
    };

    function attached() {
        if (vm.referenceNumber) {
            customsOfficeDataService.getCustomsOffice(vm.referenceNumber).then(function () {
                vm.customsOffice = customsOfficeDataService.activeCustomsOffice;
                var lsdLanguageCodes = _.map(vm.service.activeCustomsOffice.CustomsOfficeLsds, lsd => lsd.LanguageCode);
                var languageId = language.get();
                if (lsdLanguageCodes.indexOf(languageId) > -1) {
                    vm.activelsdCode = languageId;
                }
                else {
                    vm.activelsdCode = lsdLanguageCodes[0];
                }
            });
        }
        loadTranslations();
    }

    function loadTranslations() {
        return $translate([
            'shared.ui.Weekdays.Monday',
            'shared.ui.Weekdays.Tuesday',
            'shared.ui.Weekdays.Wednesday',
            'shared.ui.Weekdays.Thursday',
            'shared.ui.Weekdays.Friday',
            'shared.ui.Weekdays.Saturday',
            'shared.ui.Weekdays.Sunday'
        ]).then(function (translations) {
            vm.translations = translations;
        });
    }

    function clickReference(reference) {
        $location.url('/customs-offices/' + reference);
    }

    function showCountryHolidays() {
        customsOfficeDataService.loadHolidays(customsOfficeDataService.activeCustomsOffice.Country.CountryCode,
            customsOfficeDataService.activeCustomsOffice.RegionCode).then((result) => {
                countryHolidayModal.show(result);
            });
    }

    function detached() {
    }

    function selectLanguage(language) {
        vm.activelsdCode = language;
    }

    function back() {
        $window.history.back();
    }

    return vm;
}
